import React, { useState } from "react";
import { Modal, Input, Button, Form, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { updateEmail } from "../../../network";
import { toastError, toastSuccess } from "../../../helpers/toasters";

function EmailModal({ open, setOpen }) {
  const [form] = Form.useForm();
  const [emailValue, setEmailValue] = useState("");
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        setLoading(true);
        const payload = {
          email: emailValue.trim(),
        };
        updateEmail(
          payload,
          (res) => {
            toastSuccess(res?.message);
            setOpen(false);
            setLoading(false);
          },
          (err) => {
            toastError(err?.message || "An error occurred!");
            setLoading(false);
          }
        );
      })
      .catch((err) => {
        toastError(err?.message || "An error occurred!");
      });
  };

  return (
    <Modal
      open={open}
      centered
      footer={null}
      maskClosable={false}
      closable={false}
      width={700}
    >
      <div
        className="d-flex flex-column"
        style={{ width: "70%", margin: "auto" }}
      >
        <Typography.Title
          level={4}
          className="text-center"
          style={{ marginBottom: 24, alignSelf: "start" }}
        >
          {t("emailModal.msg")}
        </Typography.Title>

        <Form form={form} layout="vertical">
          <Form.Item
            label={
              <strong style={{ color: "#176B87" }}>
                {t("emailModal.title")}
              </strong>
            }
            name="email"
            rules={[
              {
                validator: (_, val) => {
                  const v = (val ?? "").toString().trim();

                  // Check if empty
                  if (!v) {
                    return Promise.reject(new Error(t("emailModal.required")));
                  }

                  // Email regex validation
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailRegex.test(v)) {
                    return Promise.reject(
                      new Error(t("emailModal.invalidEmail"))
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              placeholder={t("emailModal.placeholder")}
              value={emailValue}
              style={{ borderRadius: "8px" }}
              onChange={(e) => {
                setEmailValue(e.target.value);
                form.setFieldsValue({ email: e.target.value });
              }}
              size="large"
              type="email"
            />
          </Form.Item>

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
            className="w-100"
            style={{
              background: "#0db14b",
              borderColor: "#0db14b",
              borderRadius: "16px",
              maxHeight: "58px",
              fontSize: "24px",
              fontWeight: "700",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            Confirm
          </Button>
        </Form>
      </div>
    </Modal>
  );
}

export default EmailModal;
